export default __webpack_public_path__ + "static/media/chang.78c19006.jpg";